import { Grid, Paper } from '@mui/material';
import { useSnackbar } from 'notistack';
import { SubmitHandler } from 'react-hook-form';
import { useMutation } from 'react-query';
import { useNavigate, useParams } from 'react-router';
import * as api from '../../api/app/monitoredProcessDataApi';
import { AssetFullPathHeader } from '../../components/core/AssetFullPathHeader/AssetFullPathHeader';
import { PageContent } from '../../components/core/PageContent/PageContent';
import { AssetDetailTabValues, MonitoredPanelValues } from '../../types/app/asset.types';
import { MonitoredProcessDataInputs } from '../../types/app/monitoredProcessData.types';
import { dictionary } from '../../utils/core/dictionary';
import { paths } from '../../utils/core/routes';
import { MonitoredProcessDataForm } from './MonitoredProcessDataForm';
import { useStyles } from './MonitoredProcessDataForm.styles';

export function MonitoredProcessDataCreate() {
  const classes = useStyles();
  const { enqueueSnackbar } = useSnackbar();
  const navigate = useNavigate();
  const { parentId } = useParams();
  const { mutate: mutateCreateMonitoredProcessData } = useMutation(api.createMonitoredProcessData);

  const handleOnSubmit: SubmitHandler<MonitoredProcessDataInputs> = (
    data: MonitoredProcessDataInputs,
  ) => {
    data.parentAssetId = Number(parentId);
    mutateCreateMonitoredProcessData(
      { ...data },
      {
        onSuccess: () => {
          enqueueSnackbar(dictionary.MONITORED_PROCESS_DATA_CREATED, { variant: 'success' });
          navigate(`${paths.ASSETS_DETAIL}/${parentId}`, {
            state: {
              tabValue: AssetDetailTabValues.MONITORED_VALUES,
              panelValue: MonitoredPanelValues.MONITORED_PROCESS_DATA,
            },
          });
        },
        onError: (result: any) => {
          enqueueSnackbar(`${result}`, { variant: 'error' });
        },
      },
    );
  };

  return (
    <>
      <AssetFullPathHeader
        finalTitle={dictionary.MONITORED_PROCESS_DATA_CREATE}
        parentId={Number(parentId)}
      />
      <PageContent>
        <Grid container spacing={1}>
          <Grid item xs={12} md={8} lg={4}>
            <Paper className={classes.paper}>
              <MonitoredProcessDataForm
                onSubmit={handleOnSubmit}
                onBack={() =>
                  navigate(`${paths.ASSETS_DETAIL}/${parentId}`, {
                    state: {
                      tabValue: AssetDetailTabValues.MONITORED_VALUES,
                      panelValue: MonitoredPanelValues.MONITORED_PROCESS_DATA,
                    },
                  })
                }
              />
            </Paper>
          </Grid>
        </Grid>
      </PageContent>
    </>
  );
}
